<template>
  <div>
    <CustomChart ref="chart" :data="functionData" @column-update="chartUpdated">
      <template slot="actions">
        <div class="balance-display">
          <h3>Stanje: {{ priceDisplay(metaData.diff) }}</h3>
        </div>
      </template>
    </CustomChart>
    <SearchTable
      ref="table"
      :header="{
        title: 'Transakcije',
        icon: 'rule',
        class: 'md-card-header-brand',
      }"
      :queriedData="payments"
      :metaData="metaData"
      :getItems="getTransactions"
      :forEachSelected="[
        {
          function: deletePayments,
          class: 'md-danger',
          label: 'Briši',
          icon: 'delete',
        },
      ]"
      :params="params"
      :sortBy="'dateSigned'"
      :newItem="addTransation"
      :templates="getTemplates"
    >
      <div slot="header" class="header-filler md-layout">
        <div
          class="ml-auto accounts-section"
          :class="showTransfer || 'hidden-accounts-section'"
        >
          <md-button
            class="minimize md-just-icon md-simple md-round"
            @click="showTransfer = !showTransfer"
          >
            <md-icon> {{ showTransfer ? 'minimize' : 'crop_din' }} </md-icon>
          </md-button>
          <div class="md-layout" v-if="showTransfer">
            <md-field class="md-layout-item md-size-50 md-medium-size-100">
              <label> Datum </label>
              <md-datepicker v-model="transfer.date"> </md-datepicker>
            </md-field>

              <md-field class="md-layout-item md-size-50 md-medium-size-90">
              <label> Napomena </label>
              <md-input
                v-model="transfer.comment"
              >
              </md-input>
            </md-field>

            <md-field class="md-layout-item md-size-33 md-medium-size-100">
              <label> Sa Računa </label>
              <md-select v-model="transfer.from">
                <md-option
                  v-for="(bankAccount, index) in metaData.bankAccounts"
                  :key="index"
                  :value="bankAccount.id"
                  >{{ bankAccount.bankAccount }}</md-option
                >
              </md-select>
              <md-icon> east </md-icon>
            </md-field>
            <md-field class="md-layout-item md-size-33 md-medium-size-100">
              <label> Na Račun </label>
              <md-select v-model="transfer.to">
                <md-option
                  v-for="(bankAccount, index) in metaData.bankAccounts"
                  :key="index"
                  :value="bankAccount.id"
                  >{{ bankAccount.bankAccount }}</md-option
                >
              </md-select>
            </md-field>

            <md-field class="md-layout-item md-size-33 md-medium-size-100">
              <label> Iznos € </label>
              <md-input
                v-model="transfer.amount"
                type="number"
                min="0.01"
                step="0.01"
              >
              </md-input>
              <md-button
                class="transfer-button md-round md-just-icon md-success md-simple"
                @click="makeTransfer()"
              >
                <md-icon> send </md-icon>
              </md-button>
            </md-field>
          </div>
          <md-icon v-else> sync_alt </md-icon>
        </div>
      </div>
    </SearchTable>
  </div>
</template>

<script>
import Swal from 'sweetalert2';
import SearchTable from '@/components/SearchTable.vue';
import CustomChart from '@/components/Cards/CustomChart.vue';
import services from '@/api/services';
import api from '@/api/api.js';
import { cases } from '@/utils/helpers';

export default {
  components: {
    CustomChart,
    SearchTable,
  },
  computed: {
    getTemplates() {
      return this.metaData?.bankAccounts?.map((bankAccount) => {
        return {
          name: bankAccount.bankAccount,
          params: {
            dateSigned: [null, null],
            amount: [null, null],
            bankAccountId: [bankAccount.id],
            paymentDirection: ['to', 'from'],
            clientName: '',
            comment: '',
          },
        };
      });
    },
  },
  data() {
    return {
      payments: null,
      metaData: null,
      params: {
        dateSigned: [null, null],
        amount: [null, null],
        bankAccountId: ['all', 1, 2, 3, 4],
        paymentDirection: ['to', 'from'],
        clientName: '',
        comment: '',
      },
      transfer: {
        date: new Date(),
        comment: 'Transfer',
        from: 1,
        to: 2,
        amount: 1,
      },
      showTransfer: false,
      functionData: {
        labels: [],
        series: [],
      },
      chartMode: 'Bar',
    };
  },
  methods: {
    getTransactions(printTable = false) {
      const offset = this.metaData ? this.$refs.table.from : 0;
      const limit = this.metaData ? this.$refs.table.pagination.perPage : 75;
      const sortBy = this.metaData ? this.$refs.table.currentSort : null;
      const sortOrder = this.metaData
        ? this.$refs.table.currentSortOrder
        : null;
      const columns = this.metaData ? this.$refs.chart.columns : 12;
      const mode = this.metaData ? this.$refs.chart.mode : 'Bar';
      return api
        .get(services.transactions.getTransactions, {
          getTransactions: true,
          params: this.params,
          offset,
          limit,
          sortBy,
          sortOrder,
          columns,
          mode,
          printTable,
        })
        .then((data) => {
          if (data.data) this.payments = data.data;
          if (data.metaData) this.metaData = data.metaData;
          if (data.metaData.labels)
            this.functionData.labels = data.metaData.labels;
          if (data.metaData.data) this.functionData.series = data.metaData.data;
          if (data.metaData.legend)
            this.functionData.legend = data.metaData.legend;
          if (this.$refs.chart) this.$refs.chart.updateChart();
        })
        .catch((error) => {
          this.alertError(error);
        });
    },
    makeTransfer() {
      api
        .post(services.transactions.makeTransfer, {
          makeTransfer: true,
          transfer: JSON.stringify(this.transfer),
        })
        .then(() => {
          this.getTransactions();
        })
        .catch((error) => {
          this.alertError(error);
        });
    },
    deletePayments(items) {
      const ids = items
        .filter((el) => el.rowType === 'payment')
        .map((el) => el.id);
      return Swal.fire({
        title: 'Obriši uplate?',
        text: `Da li ste sigurni da želite da obrišete ${ids.length} ${cases(
          ids.length,
          'uplatu',
          'uplate',
          'uplata',
        )}?`,
        type: 'warning',
        showCancelButton: true,
        confirmButtonClass: 'md-button md-danger btn-fill',
        cancelButtonClass: 'md-button btn-fill',
        confirmButtonText: 'Obriši!',
        cancelButtonText: 'Otkaži',
        buttonsStyling: false,
      }).then((data) => {
        if (data.value) {
          (() => {
            if (ids.length >= 5) {
              return Swal.fire({
                title: 'Obriši uplate?',
                text: `Označili ste ${ids.length} ${cases(
                  ids.length,
                  'uplatu',
                  'uplate',
                  'uplata',
                )} za brisanje. Potvrdite još jednom da želite da nastavite.`,
                type: 'warning',
                showCancelButton: true,
                cancelButtonClass: 'md-button btn-fill',
                confirmButtonClass: 'md-button md-danger btn-fill',
                confirmButtonText: 'Obriši!',
                cancelButtonText: 'Otkaži',
                buttonsStyling: false,
              });
            } else {
              return Promise.resolve(data);
            }
          })().then((data) => {
            if (data.value) {
              api
                .post(services.payments.deletePayments, {
                  deletePayments: true,
                  ids,
                })
                .then(() => {
                  this.getTransactions();
                  this.$refs.table.removeChecked();
                })
                .catch((error) => {
                  this.alertError(error);
                });
            }
          });
        }
      });
    },
    addTransation() {},
    chartUpdated(value) {
      this.getTransactions().then(() => {
        this.chartMode = value;
      });
    },
  },
  mounted() {
    this.getTransactions();
  },
};
</script>

<style scoped lang="scss">
.account-select {
  // background-color: aquamarine;
  // height: 100px;
  width: 20em;
}
.header-filler {
  /* width: 100%; */
  padding-right: 2em;
  // transition: all 0.5s ease-in;
}

.transfer-button {
  height: 1.3em;
  /* margin: 0 1em !important; */
  top: -0.4em;
}
.balance-display {
  margin-right: 3em;
}
.minimize {
  position: absolute;
  top: -0.7em;
  right: 0.8em;
}

.accounts-section {
  max-width: 100rem;
  position: relative;
  border: 1px solid #cecece;
  border-radius: 0.6em;
  padding: 1.2em 3em 0.1em 3em !important;
  box-shadow: #e7e7e7 0px 0px 2px 1px;

  &.hidden-accounts-section {
    background-color: #cecece;
    transition: all 0.1s ease-in-out;

    & > .md-icon {
      color: rgba(79, 228, 86, 0);
      position: absolute;
      top: -0.1em;
      left: 0.8em;
    }

    &:hover {
      background-color: #fdfdfd;
      padding: 1.2em 4em 0.1em 4em !important;

      & > .md-icon {
        color: rgb(86, 212, 92);
      }
    }
  }
}

.transfer-amount-separator {
  padding: 0.5em 0.5em 0.5em 0.5em;
  text-align: right;
}
</style>
